export default {
  ERROR_TITLE: 'Une erreur est survenue',
  AUTO_LOGIN_COOKIE_DISABLE: 'Ce site nécessite l\'utilisation de cookies pour fonctionner',
  AUTO_LOGIN_EXPIRED: 'Votre lien de connexion a expiré. Pour vous connecter, utilisez la fonction "Mot de passe oublié".',
  CANNOT_RETRIEVE_PROJECT_TOKEN: 'Impossible de récupérer le projet',
  PROJECT_CLOSED_ERROR: 'Votre projet est déjà complet ! Si vous souhaitez le modifier, contactez l\'expert en charge de votre dossier.',
  room: {
    title: 'Impossible de supprimer la piece',
    message: 'La pièce ne peut pas être supprimé',
  },
  address: {
    postal_code: 'Veuillez entrez un code postal valide',
  },
};
